const Divider = ({ className = '' }) => {
  return (
    <div
      className={`h-px w-full bg-gradient-to-r from-transparent via-[var(--border)] to-transparent ${className}`}
    ></div>
  );
};

export default Divider;
